import React, { Component, createRef, Fragment } from 'react';
import { string, func } from 'prop-types';

import Clipboard from 'clipboard';

class CopyToClipboard extends Component {
  static propTypes = {
    customClasses: string,
    dataText: string,
    onClick: func,
    render: func
  }

  state = {
    copied: false
  }

  clipboardInstance = null;
  linkRef = createRef();

  componentDidMount = () => {
    this.clipboardInstance = new Clipboard(this.linkRef.current);

    this.attachEventListeners();
  }

  componentDidUpdate = () => {
    if(this.state.copied) {
      setTimeout(() => { this.handleTimeout(); }, 2000);
    }
  }

  componentWillUnmount = () => {
    this.clipboardInstance.destroy();
  }

  attachEventListeners = () => {
    this.clipboardInstance.on('success', this.handleClick);
    this.clipboardInstance.on('error', this.handleClick);
  }

  handleClick = e => {
    const { onClick } = this.props;

    e.clearSelection();

    this.setState({ copied: true });

    onClick && onClick(e); 
  }

  handleTimeout = () => {
    this.setState({ copied: false });
  }

  render () {
    const { copied } = this.state;
    const { customClasses, render, dataText, ...rest } = this.props;

    return (
      <Fragment>
        <a
          className={customClasses}
          data-clipboard-text={dataText}
          ref={this.linkRef}
          role="button"
          style={{ cursor: 'pointer' }}
          {...rest}
        >
          {render(copied)}
        </a>
      </Fragment>
    );
  } 
}

export default CopyToClipboard;


// WEBPACK FOOTER //
// ./src/components/CopyToClipboard/CopyToClipboard.js